"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ContentCard;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cta = _interopRequireDefault(require("../../cta/cta"));
var _imageWrapper = _interopRequireDefault(require("../../imageWrapper/imageWrapper"));
var _Badge = require("@JohnLewisPartnership/jl-design-system/dist/components/badge/Badge");
var _ArrowRight24PxOutlined = _interopRequireDefault(require("@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined"));
var _contentCardModule = _interopRequireDefault(require("./contentCard.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ContentCard(props) {
  var _props$icon;
  if (Object.keys(props).length === 0) return null;
  var isJlmIcon = ((_props$icon = props.icon) === null || _props$icon === void 0 || (_props$icon = _props$icon[0]) === null || _props$icon === void 0 || (_props$icon = _props$icon.props.children) === null || _props$icon === void 0 ? void 0 : _props$icon.type) === 'img';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "content-card",
    className: (0, _classnames["default"])(_contentCardModule["default"].contentCard, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _contentCardModule["default"].taupe, props.backgroundColour === 'Taupe'), _contentCardModule["default"].white, props.backgroundColour === 'White'), _contentCardModule["default"].citrine, props.backgroundColour === 'Citrine'), _contentCardModule["default"].darkTaupe, props.backgroundColour === 'Dark Taupe')),
    children: [props.image && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _contentCardModule["default"].imageWrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], _objectSpread({}, props.image))
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _contentCardModule["default"].cardBody,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": "card-header",
        className: (0, _classnames["default"])(_contentCardModule["default"].cardHeader, _defineProperty(_defineProperty(_defineProperty({}, _contentCardModule["default"].leftAligned, props.iconAlignment === 'Left'), _contentCardModule["default"].centreAligned, props.iconAlignment === 'Centre'), _contentCardModule["default"].topLeftAligned, props.iconAlignment === 'Top-Left')),
        children: [props.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-testid": "icon-container",
          className: (0, _classnames["default"])(_contentCardModule["default"].icon, _defineProperty(_defineProperty({}, _contentCardModule["default"].jldsIcon, !isJlmIcon), _contentCardModule["default"].jlmIcon, isJlmIcon)),
          children: props.icon
        }), props.cardTitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _contentCardModule["default"].cardTitle,
          children: props.cardTitle
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          className: _contentCardModule["default"].title,
          children: props.title
        })]
      }), props.content && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _contentCardModule["default"].content,
        children: props.content
      }), props.tags && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": "tags",
        className: _contentCardModule["default"].tags,
        children: props.tags.map(function (tag, i) {
          var _props$tags;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [tag, props.tags && i < ((_props$tags = props.tags) === null || _props$tags === void 0 ? void 0 : _props$tags.length) - 1 && ',']
          }, "tag_".concat(i));
        })
      }), props.readingTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _contentCardModule["default"].badgeWrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.Badge, {
          label: "".concat(props.readingTime, " min read"),
          badgeType: "--neutral_64"
        })
      }), props.ctaButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_contentCardModule["default"].itemContainer, _defineProperty({}, _contentCardModule["default"].ctaLogo, props.ctaButtons[0].type === 'logo')),
        children: props.ctaButtons.map(function (cta, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _contentCardModule["default"].ctaWrapper,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_cta["default"], _objectSpread(_objectSpread({}, cta), {}, {
              icon: _ArrowRight24PxOutlined["default"],
              variant: 'clear-dark'
            }))
          }, "".concat(cta.type, "_").concat(i));
        })
      }), !props.ctaButtons && props.logos && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_contentCardModule["default"].itemContainer),
        children: props.logos.map(function (logo, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], {
            altText: logo.altText,
            desktop: logo.desktopImage,
            tablet: logo.tabletImage,
            mobile: logo.mobileImage
          }, "logo_".concat(i));
        })
      })]
    })]
  });
}